export type FieldRequirement = "required" | "optional";

export interface WizardFieldSpec {
  name: string;
  requirement: FieldRequirement;
  /** Shown sparingly — marketplace needs that are not Tradivo-create blockers. */
  marketplaceHint?: string;
}

/** Canonical create: only these are required to persist a Tradivo product. */
export const CANONICAL_CREATE_REQUIRED = ["name", "sku"] as const;

export function wizardFieldLabel(spec: WizardFieldSpec): string {
  const star = spec.requirement === "required" ? " *" : "";
  return `${spec.name}${star}`;
}

export function isCanonicalCreateRequired(field: string, productType: "simple" | "variation" | "bundle"): boolean {
  if (field === "name") return true;
  if (field === "sku") return productType !== "variation";
  return false;
}
